import FiltersBlock, { SingleFilter } from '@/components/filters'
import Section from '@/layouts/section'
import { GRID } from '@/lib/constants'
import EmployeeList from '@/components/employee-list'
import { Employee, EmployeeTeam, TeamOverview } from '@/interfaces/schema'
import { UseOurTeamOutput } from '@/hooks/useOurTeam'

type EmployeeSectionProps = Pick<
  UseOurTeamOutput,
  | 'activeFilters'
  | 'handleCheckBoxChange'
  | 'handleToggleFilters'
  | 'handleLoadMore'
  | 'totalCount'
> &
  Pick<TeamOverview, 'ctaCard' | 'filtersCollection'> & {
    loadingContent: boolean
  } & { filteredEmployees: Employee[] | null }

const EmployeeSection = ({
  activeFilters,
  handleCheckBoxChange,
  handleToggleFilters,
  filteredEmployees,
  filtersCollection,
  loadingContent,
  handleLoadMore,
  totalCount,
  ctaCard,
}: EmployeeSectionProps) => {
  const filterData: SingleFilter[] =
    filtersCollection?.items?.map(
      ({ teamName }: Pick<EmployeeTeam, 'teamName'>) => ({
        name: teamName ?? '',
        value: teamName ?? '',
      })
    ) ?? []

  return (
    <Section className={`${GRID} mx-auto`}>
      <FiltersBlock
        filtersTitle="Type"
        className="col-start-1 col-end-3 lg:col-end-5 w-full"
        filterData={filterData}
        handleCheckBoxChange={handleCheckBoxChange}
        handleToggleFilters={handleToggleFilters}
        filters={activeFilters}
        isOpen
      />
      <EmployeeList
        className="col-start-1 col-end-3 md:col-start-3 md:col-end-7 lg:col-start-5 lg:col-end-13 w-full h-fit"
        loadingContent={loadingContent}
        filteredEmployees={filteredEmployees}
        handleLoadMore={handleLoadMore}
        totalCount={totalCount}
        ctaCard={ctaCard}
      />
    </Section>
  )
}

export default EmployeeSection
